<template src= "./index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import { Tag } from 'element-ui'

export default {
  name: 'artistList',
  
  data () {
    return {
        ko : ko,
        optionData : optionData,
        

        keywordOption :[
            {value: 'user_email', label:'Email ID'},
            {value: 'licensor_name', label:'권리자명'},
            {value: 'licensor_company', label: '회사명'},
            {value: 'album_ref',label: '자사앨범코드'},
            {value: 'track_ref',label: '자사트랙코드'},
            
            {value: 'album_barcode',label: 'UPC',},
            {value: 'album_artists',label: '아티스트명',},
            {value: 'album_artists_english',label: '아티스트명(번역)',},
        ],
        keywordType :null,
        keyword : '',

        startDate :null,
        endDate : null,
        dateType :null ,
    
        dateOption : [
            {value: 'album_release_date',label: '발매일',},
            {value: 'contract_start_date',label: '계약시작일',},
            {value: 'album_created_at',label: '등록일',},
        ],
        total : 0,
        page: {
            pageSize : 10,
            currentPage: 1,                       // 현재 페이지
            totalPage: 0,                         // 총 페이지수
        },          
        gridOptions :{ // 테이플 옵션
            onRowClicked: (event)=>{
                this.viewDetail(event)
            },
        },
        defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: false,
            rowSelection:'single'
        },
        columnDefs: [
           
            
            {headerName: '상태',  field: 'album_state',  filter: false,width: 100, cellRenderer: (data) => {
                let dd = {
                    temporary :'임시저장',
                    registration_complete : '접수', 
                    registration_canceled : '유통 취소', 
                    inspection_complete : '검수 완료', 
                    distribution_complete : '유통 완료', 
                    release_complete : '발매 완료', 
                    suspended : '유통중단', 
                    rejected : '반려' 
                }
                let color = {
                    temporary : "#4092ff",//'임시저장',
                    registration_complete : '#262c49',//'접수', 
                    registration_canceled : '#28c76f',//'유통 취소', 
                    inspection_complete : '#4092ff',//'검수 완료', 
                    distribution_complete : '#ff9f43',//'유통 완료', 
                    release_complete : '#24c1a0',//'발매 완료', 
                    suspended : '#b8c2cc',//'유통중단', 
                    rejected : '#ea5455',//'반려' 
                }
              return `
              <div class="con-vs-chip vs-chip-primary con-color" 
              style="
                background-color: ${color[data.value]} !important;
                color:#fff;
                line-height:1;
                padding:3px 5px;
                margin:13px 0; 
                font-size:13px;
                min-width:50px;
              ">
                <span style="margin:0" class="text-chip vs-chip--text">
                ${dd[data.value]}
            </span><!----></div>`
            }},
            {headerName: '앨범 등록일',      field: 'album_created_at',     filter: false,width: 200,
            cellRenderer: (data) => {
              return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
            }},
            {headerName: '앨범발매일',      field: 'album_release_date',     filter: false,width: 150,
            cellRenderer: (data) => {
              return this.fixDate(data.value, 'yyyy-MM-dd')
            }},
            {headerName: '자사앨범코드',      field: 'album_ref',     filter: false,width: 150,},

            {headerName: '앨범명',      field: 'album_name',     filter: false,width: 300,},
            {headerName: '앨범형식',      field: 'album_release_type',     filter: false,width: 150,},
            {headerName: '앨범 아티스트',      field: 'album_artists',     filter: false,width: 300, cellRenderer: (data) => {
              return data.value.join(',')
            }},

            {headerName: 'UPC',      field: 'album_barcode',     filter: false,width: 200,},
            {headerName: 'Vol No.',      field: 'track_volume',     filter: false,width: 200,},
            {headerName: 'Track No.',      field: 'track_nr',     filter: false,width: 200,},
            {headerName: '대표곡여부',      field: 'track_titletrack',     filter: false,width: 200, cellRenderer: (data) => {
              return data.value == 0 ? '' : ('Y' + data.value)
            }},
            {headerName: 'Explicit여부',      field: 'track_explicit',     filter: false,width: 200, cellRenderer: (data) => {
              return data.value ? 'Y' : 'N'
            }},
            {headerName: '자사트랙코드',      field: 'track_ref',     filter: false,width: 200,},
            
            {headerName: '트랙명',      field: 'track_name',     filter: false,width: 200,},
            {headerName: '앨범 아티스트',      field: 'track_artists',     filter: false,width: 300, cellRenderer: (data) => {
              return data.value.join(',')
            }},
            {headerName: 'ISRC',      field: 'track_isrc',     filter: false,width: 200,},
            {headerName: 'UCI',      field: 'track_uci',     filter: false,width: 200,},
            
            // {headerName: '계약시작일',      field: 'contract.start_date',     filter: false,width: 200,
            // cellRenderer: (data) => {
            //   return this.fixDate(data.value)
            // }},
            // {headerName: '발매일',      field: 'release_date',     filter: false,width: 200,
            // cellRenderer: (data) => {
            //   return this.fixDate(data.value)
            // }},
            
           
        
        ],
        tableData:[
        ],       
        
        testMessage: "최고당!",

        
    }
  },
  created(){
    console.log(this.$route.query)
    if(this.$route.query.page){
        this.page.currentPage= Number(this.$route.query.page)
    }
    if(this.$route.query.keywordType){
        this.keywordType= this.$route.query.keywordType
    }
    if(this.$route.query.keyword){
        this.keyword= this.$route.query.keyword
    }
    if(this.$route.query['date_field']) this.dateType = this.$route.query['date_field'] 
    if(this.$route.query['date_start']) this.startDate = this.$route.query['date_start'] 
    if(this.$route.query['date_end']) this.endDate = this.$route.query['date_end'] 
  },
  mounted(){
    this.$nextTick(() =>{
      this.callList()
    })
  },
  computed: {
   
  },
  watch: {
    'page.currentPage'(e){
        
        this.callList()
    },
    'page.pageSize'(){
        this.list_search()
    }
  },
  methods: {
    
    callList(){
      const option = {
          sort: 'id',
          sortorder: 'asc',
          page: this.page.currentPage-1 ,
          limit: this.page.pageSize,
          
      }
        
      let query = {}
      if(this.page.currentPage != 1){
          query['page'] = this.page.currentPage
      }
      if(this.keywordType && this.keyword != '') {
          option[this.keywordType] = this.keyword
          query['keywordType'] = this.keywordType
          query['keyword'] = this.keyword 
      }
      if(!this.valCheck(this.dateType) && !this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
          option['date_field'] = this.dateType
          option['date_start'] = this.startDate
          option['date_end'] = this.endDate

          query['date_field'] = this.dateType
          query['date_start'] = this.startDate
          query['date_end'] = this.endDate
      }
    
      this.$router.replace({query: query}).catch((e)=>{});
      
      this.loadingShow();
      
      this.$store.dispatch('LIST_TRACK', option)
      .then(result =>{
          this.loadingHide();
          this.tableData  = result.items // 권리자 목록
          
          this.total = result.total // 총인원수 
          this.filtered = result.filtered // limit에 따른 수
          //페이지 수
          const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
          this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
      }).catch(error=>{
          const status = error.status
          this.$router.replace({query: {}}).catch((e)=>{});
           this.loadingHide();
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              break;
          }
      })
    },
    
    list_search(){
      this.page.currentPage = 1  // 초기화
      this.callList()
    },
    viewDetail(event){
        this.$router.push('album/detail/'+event.data.album_id)
    }
  }
}
</script>

<style scoped>

</style>
